import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { GetDecodedToken } from 'libs/core/src/lib/utils/token-decode';
import { PartnersService } from 'libs/core/src/lib/services/partners.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import { sessionStore } from 'libs/core/src/lib/utils/session-store';
import { IBroker, SystemUserRole } from '@inshuwa-client/models';
import { map, of, switchMap, tap } from 'rxjs';
import { NzNotificationService } from 'ng-zorro-antd/notification';

export const resolveRepresentative = () => {
  const representativeService = inject(RepresentativeService);

  const partnerService = inject(PartnersService);
  const notificationService = inject(NzNotificationService);
  const decoded = GetDecodedToken();

  if (!decoded) {
    inject(Router).navigate(['/'], { replaceUrl: true });
    return of(false);
  }

  const { id, role } = decoded;

  if (
    role.toLowerCase() == SystemUserRole.PartnerRepresentative.toLowerCase() ||
    role.toLowerCase() ==
      SystemUserRole.AdminPartnerRepresentative.toLowerCase()
  ) {
    return representativeService
      .getCurrentPartner(Number(id))

      .pipe(
        tap((representative) => {
          sessionStore.setItem(
            SystemUserRole.PartnerRepresentative,
            JSON.stringify(representative),
          );
        }),
        switchMap((representative) => {
          if (localStorage.getItem('broker')) {
            const broker = JSON.parse(
              localStorage.getItem('broker')!,
            ) as IBroker;
            const message = {
              error: "You're not authorized to access this page",
            };

            return partnerService
              .brokerPartnerExists({
                brokerId: Number(broker.id),
                partnerId: Number(representative.partner.id),
              })
              .pipe(
                map((response) => {
                  if (response.status) {
                    return representative.status;
                  }

                  notificationService.error(
                    'Authorization Error',
                    message.error,
                  );
                  throw new Error(message.error);
                }),
              );
          }
          return of(false);
        }),
      );
  }

  return of(false);
};
